import _regenerator from "C:/Users/lptni/\u5F00\u53D1/dev/project/unbox-server/vue-admin/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "C:/Users/lptni/\u5F00\u53D1/dev/project/unbox-server/vue-admin/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import api from '@/api';
import FinanceCashBackAuditEdit from '../edit/index';
export default {
  name: 'FinanceCashBackAuditList',
  components: {
    FinanceCashBackAuditEdit: FinanceCashBackAuditEdit
  },
  data: function data() {
    return {
      downloadUrl: process.env.VUE_APP_DOWNLOAD_URL,
      isSelect: this.checkauthority('finance_cash_back_audit_select'),
      isPush: this.checkauthority('finance_cash_back_audit_push_message'),
      isUpload: this.checkauthority('finance_cash_back_audit_upload_hd'),
      selectForm: {
        createTimes: [],
        createTime: null,
        memberNo: '',
        payStats: null
      },
      editDisabled: false,
      dialogVisible: false,
      pageNo: 1,
      pageSize: 10,
      tableSelects: [],
      tableData: [],
      pageTotal: 0,
      centerDialogVisible: false,
      sumDataCount: {
        todyYearDataCount: 0,
        lastYearDataCount: 0,
        sumDataCount: 0
      },
      stats: []
    };
  },
  methods: {
    exportExcel: function exportExcel() {
      var par = {
        pageNo: this.pageNo,
        pageSize: this.pageSize,
        createTime: this.selectForm.createTime,
        memberNo: this.selectForm.memberNo,
        payStats: this.selectForm.payStats
      };
      if (this.selectForm.createTimes.length >= 2) {
        par.createStartTime = this.selectForm.createTimes[0];
        par.createEndTime = this.selectForm.createTimes[1];
      }
      var apiUrl = 'admin/v1/platformCashBackAudit/exportFinancePageList';
      this.downloadUtil.excelExport(apiUrl, par, '待返现明细表.xls');
    },
    tablePayStats: function tablePayStats(item) {
      return this.enums.checkEnumsValue(this.stats, item.payStats + '', '');
    },
    checkStatsDisabled: function checkStatsDisabled(item, index) {
      if (item.payStats === index) {
        return true;
      }
      return false;
    },
    checkStats: function checkStats(item) {
      return this.enums.checkEnumsValue(this.stats, item.payStats + '', '');
    },
    getImagesImage: function getImagesImage(row) {
      var url = JSON.parse(row.bankReceiptImg)[0].url;
      return this.downloadUrl + url;
    },
    getImagesImages: function getImagesImages(row) {
      var _this = this;
      var images = JSON.parse(row.bankReceiptImg);
      var urls = [];
      images.forEach(function (img) {
        urls.push(_this.downloadUrl + img.url);
      });
      return urls;
    },
    initEunmData: function initEunmData() {
      var thiz = this;
      this.enums.getFinanceCashBankAuditStats(function (result) {
        thiz.stats = result.body;
      });
    },
    handle: function handle(index, data, stats, msg) {
      var _this2 = this;
      this.$confirm('此操作将' + msg + '处理该数据, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        _this2.handleApi(index, data, stats);
      }).catch(function () {
        _this2.$message({
          type: 'info',
          message: '已取消' + msg
        });
      });
    },
    handleApi: function handleApi(index, data, stats) {
      var _this3 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var par;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              par = {
                auditCashBackId: data.auditCashBackId,
                stats: stats
              };
              _context.n = 1;
              return api.UPDATE_PLATFORMCASHBACKAUDIT(par);
            case 1:
              _context.n = 2;
              return _this3.initTableData();
            case 2:
              return _context.a(2);
          }
        }, _callee);
      }))();
    },
    dalete: function dalete(index, data) {
      var _this4 = this;
      var msg = '删除';
      if (data.isDel === 1) {
        msg = '恢复';
      }
      this.$confirm('此操作将永久' + msg + '该数据, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        _this4.daleteApi(index, data);
      }).catch(function () {
        _this4.$message({
          type: 'info',
          message: '已取消' + msg
        });
      });
    },
    daleteApi: function daleteApi(index, data) {
      var _this5 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var par;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              par = {
                auditCashBackId: data.auditCashBackId
              };
              if (data.isDel === 1) {
                par.isDel = 0;
              } else {
                par.isDel = 1;
              }
              _context2.n = 1;
              return api.UPDATE_PLATFORMCASHBACKAUDIT(par);
            case 1:
              _this5.initTableData();
            case 2:
              return _context2.a(2);
          }
        }, _callee2);
      }))();
    },
    deleteBatchApi: function deleteBatchApi(par) {
      var _this6 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              _context3.n = 1;
              return api.DELETE_BATCH_PLATFORMCASHBACKAUDIT(par);
            case 1:
              _this6.$message.success('操作成功');
              _context3.n = 2;
              return _this6.initTableData();
            case 2:
              return _context3.a(2);
          }
        }, _callee3);
      }))();
    },
    pushMessage: function pushMessage(row) {
      var _this7 = this;
      this.$confirm('推送消息之后，数据将从此列表移除, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        _this7.pushMessageApi(row);
      }).catch(function () {
        _this7.$message({
          type: 'info',
          message: '已取消'
        });
      });
    },
    pushMessageApi: function pushMessageApi(row) {
      var _this8 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4() {
        var par;
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.n) {
            case 0:
              par = {
                memberIds: [row.memberId],
                title: '返现通知',
                message: '你的官方返现' + row.cashBackAccount + '已到账, 请注意查收！祝：百年好合，幸福一生！',
                images: '',
                displayType: 1,
                messageType: 0,
                businessType: 0,
                businessId: row.auditCashBackId
              };
              _context4.n = 1;
              return api.PUSH_MEMBER_MESSAGE(par);
            case 1:
              _this8.$message.success('已推送消息');
              _context4.n = 2;
              return _this8.initTableData();
            case 2:
              return _context4.a(2);
          }
        }, _callee4);
      }))();
    },
    deleteBatch: function deleteBatch() {
      var _this9 = this;
      if (this.tableSelects.length === 0) {
        this.$message.error('请勾选要删除的表格数据');
        return;
      }
      this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        var par = [];
        _this9.tableSelects.forEach(function (element) {
          par.push(element.auditCashBackId);
        });
        _this9.deleteBatchApi(par);
      }).catch(function () {
        _this9.$message({
          type: 'info',
          message: '已取消删除'
        });
      });
    },
    info: function info(index, data) {
      this.editDisabled = true;
      this.dialogVisible = true;
      this.$refs.edit.setTitle('详情');
      this.$refs.edit.setData(data);
    },
    edit: function edit(index, data) {
      this.dialogVisible = true;
      this.editDisabled = false;
      this.$refs.edit.setTitle('上传银行回单');
      this.$refs.edit.setData(data);
    },
    toAdd: function toAdd() {
      this.$refs.edit.setTitle('新增');
      this.editDisabled = false;
      this.dialogVisible = true;
      this.$refs.edit.initData();
    },
    userEditClose: function userEditClose() {
      this.dialogVisible = false;
    },
    reset: function reset() {
      this.pageNo = 1;
      this.selectForm.createTime = null;
      this.selectForm.memberNo = '';
      this.selectForm.createTimes = [];
      this.selectForm.payStats = null;
      this.initTableData();
    },
    search: function search() {
      this.pageNo = 1;
      this.initTableData();
    },
    initTableData: function initTableData() {
      var _this0 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5() {
        var par, res;
        return _regenerator().w(function (_context5) {
          while (1) switch (_context5.n) {
            case 0:
              par = {
                pageNo: _this0.pageNo,
                pageSize: _this0.pageSize,
                createTime: _this0.selectForm.createTime,
                memberNo: _this0.selectForm.memberNo,
                payStats: _this0.selectForm.payStats
              };
              if (_this0.selectForm.createTimes.length >= 2) {
                par.createStartTime = _this0.selectForm.createTimes[0];
                par.createEndTime = _this0.selectForm.createTimes[1];
              }
              _context5.n = 1;
              return api.GET_PLATFORMCASHBACKAUDIT_FINANCE_PAGE_LIST(par);
            case 1:
              res = _context5.v;
              _this0.tableData = res.body.datas;
              _this0.pageTotal = res.body.sumDataCount;
            case 2:
              return _context5.a(2);
          }
        }, _callee5);
      }))();
    },
    handleSizeChange: function handleSizeChange(val) {
      this.pageSize = val;
      this.initTableData();
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.pageNo = val;
      this.initTableData();
    },
    handleSelectionChange: function handleSelectionChange(val) {
      this.tableSelects = val;
    }
  },
  created: function created() {
    if (this.isSelect) {
      return;
    }
    this.initEunmData();
    this.initTableData();
  }
};